import { render, staticRenderFns } from "./UserSummary.vue?vue&type=template&id=61c1dece&"
import script from "./UserSummary.vue?vue&type=script&lang=js&"
export * from "./UserSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports